export enum MaterialsFiltersIds {
    HPD = 'healthProductDeclaration',
    HPDPW = 'perkinsWillPrecautionaryListFree',
    HPDLBC = 'livingBuildingChallengeRedListFree',
    HPDC2C = 'c2cRestrictSubstancesListFree',
    Declare = 'declare',
    DeclareLBCRedList = 'declare-lbcRedListFree',
    DeclareLBCCopliant = 'declare-lbcCompliant',
    DeclareDeclared = 'declare-declared',
    C2CCertified = 'c2cCertified',
    C2CCertifiedPlatinum = 'c2cCertified-platinum',
    C2CCertifiedGold = 'c2cCertified-gold',
    C2CCertifiedSilver = 'c2cCertified-silver',
    C2CCertifiedBronze = 'c2cCertified-bronze',
    C2CMHC = 'c2cMaterialHealthCertificate',
    C2CMHCPlatinum = 'c2cMaterialHealthCertificate-platinum',
    C2CMHCGold = 'c2cMaterialHealthCertificate-gold',
    C2CMHCSilver = 'c2cMaterialHealthCertificate-silver',
    C2CMHCBronze = 'c2cMaterialHealthCertificate-bronze',
    LPC = 'livingProductChallenge',
    MFRI = 'manufacturerInventory',
}
